import React, { Component } from 'react';
import PropTypes from 'prop-types'
import _ from 'lodash'

import { searchUtils } from '../../utils'
import chevronUpIcon from '../../assets/icons/chevron-up-black.svg'
import chevronDownIcon from '../../assets/icons/chevron-down-black.svg'
import './MultiselectDropdown.sass'


class MultiselectDropdown extends Component {
  state = {
    isExpanded: false,
    filterText: '',
  }

  constructor(props) {
    super(props)
    this.multiselectContainer

    this._toggleDropdown = this.toggleDropdown.bind(this)
    this._clickOutside = this.clickOutside.bind(this)
    this._onChange = this.onChange.bind(this)
    this._renderSelectGroup = this.renderSelectGroup.bind(this)
    this._onFilterTextChange = this.onFilterTextChange.bind(this)
  }

  componentDidMount() {
    document.addEventListener('click', this._clickOutside)
    document.addEventListener('touchstart', this._clickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this._clickOutside)
    document.removeEventListener('touchstart', this._clickOutside)
  }

  // Want to close dropdown when user clicks anywhere outside of dropdown/dropdown options
  clickOutside(e) {
    if (!this.multiselectContainer || this.multiselectContainer.contains(e.target)) { return }
    this.setState({ isExpanded: false })
  }

  toggleDropdown() {
    this.setState({ isExpanded: !this.state.isExpanded })
  }

  onChange(e) {
    const { activeFilterIds, setActiveFilterIds, onUpdate } = this.props
    const selectedId = parseInt(e.target.value)

    // Call redux action with updated selected values
    if (e.target.checked) {
      // Add to active filter ids list
      const updatedSelectedIds = [...activeFilterIds, selectedId]
      setActiveFilterIds(updatedSelectedIds)
      onUpdate(updatedSelectedIds)
    } else {
      // Remove from active filter ids list
      const updatedSelectedIds = activeFilterIds.filter(filterId => filterId !== selectedId)
      setActiveFilterIds(updatedSelectedIds)
      onUpdate(updatedSelectedIds)
    }
  }

  onFilterTextChange = (e) => {
    this.setState({ filterText: e.target.value })
  }

  selectAllInGroup(idsInGroup) {
    const { options, activeFilterIds, setActiveFilterIds, onUpdate } = this.props
    const isAllAlreadySelected = idsInGroup.every(id => activeFilterIds.includes(id))

    if (isAllAlreadySelected) {
      // Unselect all if they're all already selected
      const updatedIds = searchUtils.getActiveFilterIds(activeFilterIds, [], idsInGroup)
      setActiveFilterIds(updatedIds)
      onUpdate(updatedIds)
    } else {
      const updatedIds = searchUtils.getActiveFilterIds(activeFilterIds, idsInGroup, [])
      setActiveFilterIds(updatedIds)
      onUpdate(updatedIds)
    }
  }

  renderParentCheckbox() {
    const { parentId, title, isFilteredSearch, activeFilterIds, className } = this.props

    return (
      <div className={`multiselect-dropdown-parent checkbox-radio ${className} ${isFilteredSearch ? 'checkbox-radio-sm checkbox-radio-blue' : 'checkbox-radio-green' }`}>
        <input
          type="checkbox"
          id={parentId}
          value={parentId}
          aria-selected={activeFilterIds.includes(parentId)}
          checked={activeFilterIds.includes(parentId)}
          onChange={this._onChange}
        />
        <label htmlFor={parentId}>{title}</label>
      </div>
    )
  }

  getAdditionalFilterGroups(additionalFilters, options) {
    // For each additional filter (e.g. 'all' or 'shoreline'), get all option IDs that belong to it
    // Special case for 'all' filter since it's assumed that all options belong to it
    return additionalFilters.map(additionalFilter => {
      if (additionalFilter === 'all') {
        return {
          label: _.capitalize(additionalFilter),
          ids: options.map(option => option.id)
        }
      } else {
        const ids = options.filter(option => option.meta[additionalFilter]).map(option => option.id)
        return {
          label: _.capitalize(additionalFilter),
          ids
        }
      }
    })
  }

  renderSelectGroup(filterGroup, idx, filterGroups) {
    // Check if all options' ids are selected for filter group (e.g. 'all' or 'shoreline')
    const { options, activeFilterIds, isFilteredSearch } = this.props
    const allInGroupSelected = filterGroup.ids.every(id => activeFilterIds.includes(id))

    return (
      <li
        key={idx}
        className={`
          checkbox-radio-sm
          ${isFilteredSearch ? 'checkbox-radio-blue' : 'checkbox-radio-green'}
          ${idx === filterGroups.length - 1 ? 'select-all' : '' }
        `}
      >
        <input
          type="checkbox"
          id={`select-${filterGroup.label}`}
          aria-selected={allInGroupSelected}
          checked={allInGroupSelected}
          onChange={() => this.selectAllInGroup(filterGroup.ids)}
        />
        <label htmlFor={`select-${filterGroup.label}`}>{filterGroup.label}</label>
      </li>
    )
  }

  renderOptions() {
    // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox.html
    const { options, activeFilterIds, isFilteredSearch } = this.props
    const { filterText } = this.state
    const lowercaseFilterText = filterText.toLowerCase()

    const filteredOptions = options.filter(option => option.name.toLowerCase().includes(lowercaseFilterText))

    if (!filteredOptions.length) {
      return <div className="multiselect-dropdown__no-options">No options for given filter</div>
    }

    return filteredOptions.map((option, idx) => (
      <li key={idx} className={`checkbox-radio-sm ${isFilteredSearch ? 'checkbox-radio-blue' : 'checkbox-radio-green'}`}>
        <input
          type="checkbox"
          id={option.id}
          value={option.id}
          aria-checked={activeFilterIds.includes(option.id)}
          checked={activeFilterIds.includes(option.id)}
          onChange={this._onChange}
        />
        <label htmlFor={option.id}>{option.name}</label>
      </li>
    ))
  }

  renderTextFilter = () => {
    const { isFilteredSearch } = this.props
    const { filterText } = this.state

    return (
      <div className={isFilteredSearch ? 'multiselect-dropdown__filter--blue' : 'multiselect-dropdown__filter--green'}>
        <input
          className="multiselect-dropdown__filter-input"
          type="search"
          placeholder="Filter by name..."
          value={filterText}
          onChange={this.onFilterTextChange}
        />
      </div>
    )
  }

  render() {
    const {
      title,
      isFilteredSearch,
      className,
      options,
      activeFilterIds,
      additionalFilters,
      displayTextFilter,
    } = this.props
    const { isExpanded } = this.state
    const additionaFilterGroups = this.getAdditionalFilterGroups(additionalFilters, options)

    if (options.length === 0) {
      return this.renderParentCheckbox()
    }

    // Get the amount of selected options in the dropdown
    const allOptionIds = options.map(opt => opt.id)
    const selectedOptionAmt = _.intersection(activeFilterIds, allOptionIds).length

    return (
      <div
        className={`multiselect-dropdown ${className} ${isFilteredSearch && 'filtered-search-multiselect'}`}
        aria-multiselectable="true"
        role="multiselect"
        ref={node => this.multiselectContainer = node}
      >
        <div style={{margin: '0 auto'}}>
          <button
            type="button"
            role="toggle-multiselect"
            aria-label="toggle multiselect"
            className={`toggle-btn ${isExpanded ? 'is-expanded' : ''}`}
            onClick={this._toggleDropdown}
          >
            <span>
              {title}
              { selectedOptionAmt ? ` (${selectedOptionAmt})`  : '' }
            </span>
            <img src={isExpanded ? chevronDownIcon : chevronUpIcon} alt="chevron icon" />
          </button>
          { isExpanded &&
            <ul aria-expanded={isExpanded}>
              {displayTextFilter && this.renderTextFilter()}
              {additionaFilterGroups.map(this._renderSelectGroup)}
              {this.renderOptions()}
            </ul>
          }
        </div>
      </div>
    )
  }
}

MultiselectDropdown.propTypes = {
  parentId: PropTypes.number,
  options: PropTypes.array,
  title: PropTypes.string,
  isFilteredSearch: PropTypes.bool,
  displayTextFilter: PropTypes.bool,
  className: PropTypes.string,
  activeFilterIds: PropTypes.array,
  setActiveFilterIds: PropTypes.func,
  onUpdate: PropTypes.func,
  additionalFilters: PropTypes.array
}

MultiselectDropdown.defaultProps = {
  onUpdate: () => {},
  isFilteredSearch: false,
  className: ''
}

export default MultiselectDropdown
